// App icons are images, not Lucide icons
export const apps = [
  {
    id: "scribemind",
    name: "ScribeMind",
    tagline: "Learn Smarter, Not Harder",
    shortDescription: "Record, transcribe, and understand your lectures with AI-powered summaries and study tools.",
    description: "ScribeMind transforms how you learn by recording and transcribing lectures or sessions, then summarizing key points and explaining complex concepts in easy-to-understand language. Combine transcripts and test your knowledge through timed examinations.",
    features: [
      "Records & transcribes lectures and sessions",
      "AI-powered summaries of your content",
      "Explains key concepts in simple language",
      "Combine transcripts for comprehensive review",
      "Timed examinations to test knowledge"
    ],
    idealFor: "Students, Professionals who value learning",
    image: "https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=800&auto=format&fit=crop&q=80",
    iconImage: "https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=256&auto=format&fit=crop&q=80",
    appStoreUrl: "https://apps.apple.com/ca/app/scribemind/id6758567211",
    privacyUrl: "/privacy/scribemind"
  },
  {
    id: "selah-daily",
    name: "Selah Daily",
    tagline: "Grow Spiritually, Daily",
    shortDescription: "Transform sermons into 5-day devotionals for deeper spiritual growth and reflection.",
    description: "Selah Daily helps you grow spiritually by recording sermons, providing summaries, and generating 5-day devotionals based on the message. Track your progress with the streak manager, translate devotionals to your language of choice, and share with others.",
    features: [
      "Records sermon and provides transcription",
      "AI-generated sermon summaries",
      "5-day devotional creation from sermons",
      "Progress tracking with streak manager",
      "Translate and share devotionals"
    ],
    idealFor: "Anyone who values spiritual growth",
    image: "https://images.unsplash.com/photo-1504052434569-70ad5836ab65?w=800&auto=format&fit=crop&q=80",
    iconImage: "https://images.unsplash.com/photo-1504052434569-70ad5836ab65?w=256&auto=format&fit=crop&q=80",
    appStoreUrl: "https://apps.apple.com/ca/app/selah-daily/id6758280709",
    privacyUrl: "/privacy/selah-daily"
  },
  {
    id: "clean-eats",
    name: "Clean Eats",
    tagline: "Eat Clean, Live Better",
    shortDescription: "Extract recipes from social media, swap ingredients for healthier options, and track nutrition.",
    description: "Clean Eats makes healthy cooking easy by extracting recipes from social media links, providing step-by-step instructions, and helping you replace ingredients with cleaner alternatives. Track your nutrition and discover community recipes.",
    features: [
      "Extract recipes from social media links",
      "Step-by-step cooking instructions",
      "Replace ingredients with healthier alternatives",
      "Nutrition tracking",
      "Discover community recipes"
    ],
    idealFor: "Busy couples and families who value clean eating",
    image: "https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=800&auto=format&fit=crop&q=80",
    iconImage: "https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=256&auto=format&fit=crop&q=80",
    appStoreUrl: null,
    privacyUrl: null
  },
  {
    id: "clonestudio",
    name: "CloneStudio",
    tagline: "Create with AI",
    shortDescription: "Powerful AI creation tools for content and media. Coming soon.",
    description: "CloneStudio brings powerful AI creation capabilities to your fingertips. More details coming soon as we prepare for launch.",
    features: [
      "AI-powered creation tools",
      "Content generation",
      "Media processing",
      "Coming soon"
    ],
    idealFor: "Creators and content makers",
    image: "https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?w=800&auto=format&fit=crop&q=80",
    iconImage: null,
    appStoreUrl: null,
    privacyUrl: null
  }
];
